import { Box } from '@modusign/design-system';
import { FontType, TextAlign } from '@modusign/react-signing/types';
import { useState } from 'react';
import { useCallbackRef } from 'use-callback-ref';

import { createAbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/libs/createAbsoluteSize';
import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import DropdownFieldDropdownPreview from '@app/features/apply-react-signing/components/FieldSetupStep/DropdownFieldPreview';
import { useTransformTextStyle } from '@app/features/apply-react-signing/libs/hooks/useTransFormTextStyle';
import PDFFontNormalizer from '@app/libs/reactPdfJs/utils/PDFFontNormalizer';

interface DropdownFieldMousePlaceholderProps {
  fontFamily: FontType;
  fontSize: number;
  required: boolean;
  textAlign: TextAlign;
  participantOrder: number;
  scale: number;
}

const defaultProps = {
  latestFieldData: null,
  participantOrder: 1,
  scale: 1,
};

function DropdownFieldMousePlaceholder({
  fontFamily,
  fontSize,
  required,
  textAlign,
  participantOrder,
  scale,
}: DropdownFieldMousePlaceholderProps) {
  const fontPixelSize = PDFFontNormalizer.toPixelFontSize({ fontSize }, scale);

  // FIXME: 하위에 렌더링 되는 HTMLSelect에 의해 결정되는 필드의 크기로 인해 ref를 사용해야 합니다.
  // 이때 ref가 설정되었다면 이 컴포넌트를 리렌더링 하여 사용할 값을 업데이트 해야합니다.
  // 더 좋은 방법이 있다면 수정하면 좋을 것 같습니다.
  const [, forceUpdate] = useState<unknown>(null);

  const selectRef = useCallbackRef<HTMLSelectElement>(null, () => forceUpdate({}));

  const size: AbsoluteSize = (() => {
    if (!selectRef.current) {
      return createAbsoluteSize({
        width: 0,
        height: 0,
      });
    }
    const clientRect = selectRef.current.getBoundingClientRect();
    return createAbsoluteSize({
      width: clientRect.width,
      height: clientRect.height,
    });
  })();

  const { transformTextStyle } = useTransformTextStyle({
    size,
    fontFamily,
    fontSize,
    textAlign,
    scale,
  });

  return (
    <Box height={size.height} position="absolute" width={size.width}>
      <DropdownFieldDropdownPreview
        fontPixelSize={fontPixelSize}
        options={[]}
        participantOrder={participantOrder}
        restrictTextClick
        selectRef={selectRef}
        star={required}
        style={transformTextStyle}
      />
    </Box>
  );
}

DropdownFieldMousePlaceholder.defaultProps = defaultProps;

export default DropdownFieldMousePlaceholder;
